import React from "react";
import ListingGrid from "../../../components/landing/ListingGrid";
import type { StaySubcategory } from "./StaySearchBar";

// Shown when a live listing has no photo of its own
const FALLBACK_IMAGES = [
  "/figma-assets/stay/intro-hotels.jpg",
  "/figma-assets/stay/intro-apartments.jpg",
  "/figma-assets/stay/intro-boutique.jpg",
  "/figma-assets/stay/hotels.jpg",
  "/figma-assets/stay/list-property.jpg",
  "/figma-assets/stay/boutique-detail.jpg",
];

type StayListingsProps = {
  subcategories: StaySubcategory[];
};

export default function StayListings({ subcategories }: StayListingsProps) {
  return (
    <ListingGrid
      categoryId={2}
      eyebrow="Browse"
      title="Find Your Stay"
      subcategories={subcategories}
      fallbackImages={FALLBACK_IMAGES}
      itemLabel="Stay"
      emptyText="No stays are listed here yet."
      emptyCta={{ label: "Search all stays", to: "/workspaces-search?type=stay" }}
    />
  );
}
